import React from 'react';
import ReactDOM from 'react-dom/client';
import NexusLearnApp from './NexusLearnDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NexusLearnApp />
  </React.StrictMode>
);
